import React from "react";
import { frameSettings } from "shared/utils/doorConfigurations";
import { useConfigurationOptionsContext } from "../../../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getDoubleFramePositions,
  getFrameScaling,
} from "../../../../../../../shared/utils/door";
import { getFullAssetPath } from "shared/utils/assets";
import { useGLTF } from "@react-three/drei";
import { SilverHandlesGLTFResult } from "../../enkel/handlesType";

interface FrameActiveProps extends frameSettings {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
}

const FrameActive: React.FC<FrameActiveProps> = ({
  doorNodes,
  materials,
  index,
  ...frameSettings
}: FrameActiveProps) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationColor,
    handle,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getDoubleFramePositions(width, height, "left");
  const scaling = getFrameScaling(width, height);

  const yPositionSides = -0.01 * (-1 * (1 - scaling.vertical.y));

  const { materials: materialsHandle } = useGLTF(
    getFullAssetPath("/objects-v3/kaderdeurSilverHandles-v1.glb"),
  ) as SilverHandlesGLTFResult;

  // Determine hinge color based on handle type (zwart, rvsilver)
  const hingeColor = handle?.code.includes("zwart")
    ? materials["PoedercoatGitZwart"]
    : materialsHandle.MergedBake_Baked;

  return (
    <group dispose={null}>
      <mesh
        geometry={doorNodes["frame_top_active"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.horizontal}
        position={[
          positions.top.x - 0.025,
          positions.top.y - 0.002,
          positions.top.z,
        ]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_bottom_active"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.horizontal}
        position={[
          positions.bottom.x - 0.025,
          positions.bottom.y,
          positions.bottom.z,
        ]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_left_active"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={[positions.left.x, yPositionSides, 0]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_right_active"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={[positions.right.x, yPositionSides, 0]}
      ></mesh>
      <group>
        <mesh
          geometry={doorNodes["hinge_2_active"].geometry}
          rotation={[0, 0, 0]}
          material={hingeColor}
          position={[
            positions.left.x,
            positions.top.y + (frameSettings?.frameTop?.shiftY ?? 0),
            0,
          ]}
        ></mesh>
        <mesh
          geometry={doorNodes["hinge_1_active"].geometry}
          rotation={[0, 0, 0]}
          material={hingeColor}
          position={[
            positions.left.x,
            positions.top.y + (frameSettings?.frameTop?.shiftY ?? 0),
            0,
          ]}
        ></mesh>
        <mesh
          geometry={doorNodes["hinge_0_active"].geometry}
          rotation={[0, 0, 0]}
          material={hingeColor}
          position={[positions.left.x, positions.bottom.y, 0]}
        ></mesh>
      </group>
    </group>
  );
};

export default FrameActive;
